// @ts-nocheck

import CodeMirror from 'codemirror';

CodeMirror.lintValidator = function(text, updateLinting, lintOptions, cm) {
  if (text.trim() === '') {
    updateLinting(cm, []);
  }

  function validatorResponseCallback(errorList) {
    const found = [];

    for (const i in errorList) {
      const error = errorList[i];

      const startLine = error.line_no;

      let startChar;
      if (typeof error.column_no_start !== 'undefined') startChar = error.column_no_start;
      else startChar = error.column_no;

      let endChar;
      if (typeof error.column_no_stop !== 'undefined') endChar = error.column_no_stop;
      else endChar = error.column_no;

      const endLine = error.line_no;
      const { message } = error;

      let severity;
      if (typeof error.severity !== 'undefined') severity = error.severity;
      else severity = 'error';

      found.push({
        from: CodeMirror.Pos(startLine - 1, startChar),
        to: CodeMirror.Pos(endLine - 1, endChar),
        message,
        severity // "error", "warning"
      });
    }

    updateLinting(cm, found);
  }

  lintOptions.getLintValidator(text, cm, validatorResponseCallback);
}
